<div
    *ngIf="isVisible"
    (click)="onBackdropClick($event)"
>
    <div class="flex flex-column w-full h-full justify-content-center  pb-3">

            <div class="h-18rem flex justify-content-center align-items-center" *ngIf="content.imageSrc">
                <div class="h-full w-auto" [ngClass]="{
                        'bordered-image-cont': mode === TierUpgradeMode.moreAirports || mode === TierUpgradeMode.moreDestinations
                    }">
                <img
                    class="h-full"
                    [ngClass]="{
                        'bordered-image': mode === TierUpgradeMode.moreAirports || mode === TierUpgradeMode.moreDestinations
                    }"
                    [src]="content.imageSrc"
                    alt="hero-image"/>

                <p-tag
                    *ngIf="mode === TierUpgradeMode.moreDestinations"
                    severity="success"
                    [rounded]="true"
                    styleClass="absolute top-0 right-0 mt-4 mr-4"
                    [style]="{ width: '22.75px', height: '22.75px' }"
                >
                    <i class="ph-fill ph-heart text-red-500 text-lg"></i>
                </p-tag>
                </div>
        </div>
        <h4 class="text-center mb-3 text-3xl font-bold" [innerHTML]="content.title"></h4>
        <p class="text-md text-center mb-4 text-900" [innerHTML]="safeMessage"></p>
                <p-button
          label="{{ content.buttonText }}"
          styleClass="learn-btn w-full"
          severity="info"
          (click)="onAction()"
        ></p-button>
    </div>
</div>
